export function getControls() {
    const trackEventBtn = document.getElementById('track-event');

    if (!trackEventBtn) {
        throw new Error('Controls are not ready');
    }

    return {
        trackEventBtn,
    };
}
